import { Dialog } from 'primereact/dialog'
import React from 'react'
import close from '../../assets/imgs/buttons/close.svg'
import './modal.scss'

const Modal = ({
  isShowing,
  hide,
  width,
  maxWidth,
  height,
  maxHeight,
  title,
  context,
}) => {
  const customStyles = {
    // content: {
    //     width,
    //     maxWidth
    // },
    width,
    maxWidth,
    height,
    maxHeight,
  }

  return (
    <div>
      {isShowing && (
        <Dialog
          className="general-modal"
          visible={isShowing}
          onHide={hide}
          style={customStyles}
          header={<h2 className="general-modal__title">{title}</h2>}
          modal
          closable={false}
        >
          <span
            className="general-modal__close"
            onClick={() => hide()}
            aria-hidden="true"
          >
            <img src={close} alt="close" />
          </span>
          <div className="content-modal">{context}</div>
        </Dialog>
      )}
    </div>
  )
}

export default Modal
